import { Injectable, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataService } from '../shared/services/data.service';
import { SupportedBrowsersResponse } from '../model/supported-browsers-response.model';
import { UnsupportedBrowserAlertComponent } from './unsupported-browser-alert.component';

@Injectable({
  providedIn: 'root'
})
export class BrowserUIService {

  constructor(
    private dataService: DataService,
    private dialog: MatDialog,
    ) { }

  checkBrowserSupport() {
    console.log('checkBrowserSupport');

    // if we have already shown the message to the user, we don't need to 
    // show it again... until the next login.
    if (this.getHasShown()) return;

    this.dataService.getSupportedBrowsers()
    .subscribe((sbr: SupportedBrowsersResponse) => {
      console.log('checkBrowserSupport: SupportedBrowsersResponse', sbr);

      // do nothing -- should never happen!
      if (sbr == null || sbr === undefined) return;

      // check if message has been shown, due to multiple requests
      if (this.getHasShown()) return;

      // set a flag, so that we show this message once per auth session
      this.setHasShown(true);

      // if we support this browser, don't show the message
      if (sbr.IsSupported) return;

      // -------------------------------------
      // show the message to the user...
      // -------------------------------------

      this.dialog.open(UnsupportedBrowserAlertComponent, {
        panelClass: 'unsupported-browser-panel',
        width: '600px', 
        autoFocus: false,
        data: sbr
      });

    });

  }  

  getHasShown() : boolean {
    let flag = sessionStorage.getItem('UnsupportedBrowser_HasShown');
    console.log('getHasShown: flag', flag);
    return flag == 'Y';
  }

  setHasShown(value: boolean){
    sessionStorage.setItem('UnsupportedBrowser_HasShown', value == true ? 'Y' : 'N');
  }

}
